import React from "react";
import { FaExternalLinkAlt, FaShoppingCart } from "react-icons/fa";
import {
  resolveProductBuyLinkType,
  resolveProductBuyUrl,
} from "../../utils/productBuyUrl";
import { openTrackedOutboundUrl } from "../../utils/trackOutboundClick";
import { readHomeChatMatchSessionId } from "../../utils/homeChatMatchPersistence";
import styles from "../../styles/pages/product/ProductDetailsPage.module.css";

/**
 * Primary commerce CTA. Hidden until purchaseUrl or affiliateUrl is set.
 */
const ProductBuyCta = ({ product }) => {
  const url = resolveProductBuyUrl(product);
  if (!url) return null;

  const isAffiliate = resolveProductBuyLinkType(product) === "affiliate";
  const label = isAffiliate ? "See price" : "See retailer";

  const handleClick = async () => {
    await openTrackedOutboundUrl({
      url,
      productId: product?._id,
      source: "product_details",
      linkType: resolveProductBuyLinkType(product),
      sessionId: readHomeChatMatchSessionId() || undefined,
    });
  };

  return (
    <div className={styles.productBuyCta}>
      <button
        type="button"
        className={styles.productBuyBtn}
        onClick={handleClick}
      >
        <FaShoppingCart aria-hidden />
        {label}
        <FaExternalLinkAlt className={styles.productBuyBtnIcon} aria-hidden />
      </button>
    </div>
  );
};

export default ProductBuyCta;
